
























































































































import { Component, Vue} from 'vue-property-decorator';
import { BvTableFieldArray } from 'bootstrap-vue';
import { IDelivery } from '@/core/models/IDelivery';
import { backendService } from '@/services/backend-service';
import moment from 'moment';
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import 'moment/locale/pt-br';
import DeliveryHelper  from '@/core/DeliveryHelper';

moment.locale("nb");

Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker);

@Component({
  name: 'Quality',
  components: {
    VueCtkDateTimePicker
  },
})
export default class extends Vue {
  sumRowActive= true
  busyState = true;
  sortBy = "time";
  label="Velg måned og år som skal vises:";
  language="nb";
  datePickerRerenderKeyKey = 0;
  items: IDelivery[] = [];
  uniqueDeliveries: IDelivery[] = [];
  filteredTests: IDelivery[] = [];
  today = new Date()
  firstDayMonth = new Date(this.today.getFullYear(), this.today.getMonth(), 1);
  filter = null;
  filterDate= { "start": this.firstDayMonth.toISOString(), "end": this.today.toISOString()};
  customShortcut = [
  { key: 'thisMonth', label: 'Denne md ', value: 'month' },
  { key: 'lastMonth', label: 'Forrige md', value: '-month' },
  {
    key: 'last3Months',
    label: 'Siste 3 md',
    value: () => {
      return {
        end: moment(),
        start: moment().add(-3, 'months')
      }
    },
    callback: ({ start, end }) => {
      this.filterDate.end = end;
      this.filterDate.start = start;
    }
  },
  { key: 'thisYear', label: 'Dette året', value: 'year' },
  { key: 'lastYear', label: 'Forrige år', value: '-year' },
 {
  key: 'twoYear',
  label: '2 år',
  value: () => {
    return {
      end: moment(),
      start: moment().add(-2, 'years')
    }
  },
  callback: ({ start, end }) => {
    this.filterDate.end = end;
    this.filterDate.start = start;
  }
  },
  {
    key: 'fiveYear',
    label: '5 år',
    value: () => {
      return {
        end: moment(),
        start: moment().add(-5, 'years')
      }
    },
    callback: ({ start, end }) => {
      this.filterDate.end = end;
      this.filterDate.start = start;
    }
  },
  {
    key: 'allDeliveries',
    label: 'Alle leveranser',
    value: () => {
      return {
        end: moment(),
        start: moment("2015-09-10")
      }
    },
  }
  ];
  sortDesc= false;
  sortDirection= 'asc';

  beforeMount() {
    if (!this.$route.query.bilagsnummer && this.$root.$data.QualityFilterDate !== undefined) {
      this.filterDate = this.$root.$data.QualityFilterDate;
    }
  }
  
  mounted() {
    this.forceVueCtkDateTimePickerComponentToRerender();
    this.load();
  }

  // VueCtkDateTimePicker does not correctly set localization on load, så have to force an update
  // https://github.com/chronotruck/vue-ctk-date-time-picker/pull/263
  // using best practice for update: https://michaelnthiessen.com/force-re-render/
  forceVueCtkDateTimePickerComponentToRerender() {
    this.datePickerRerenderKeyKey += 1;  
  }

  setToLoaded() {
    this.$root.$data.statusMessage = 'Loaded';
    console.log("loaded")
  }

  load() {
    if (this.$route.query.bilagsnummer) {
      this.$root.$data.QualityFilterDate = undefined;
      backendService
        .getVoucher(this.$route.query.bilagsnummer.toString())
        .then(res => {
          let items = JSON.parse(res.request.response).response;
          let itemsShowingDetails = items.map(item => ({...item, _showDetails: true }));
          this.items = itemsShowingDetails; 
          this.uniqueDeliveries = DeliveryHelper.getUniqueDeliveries(itemsShowingDetails);
          this.filterDate.start = (this.uniqueDeliveries[0].time).toString()
          this.busyState = false;
        })
        .catch(err => {
          console.log(err);
          this.$root.$data.statusMessage = 'Leveranser ikke funnet!';
      });
      this.sumRowActive = false
    }
    else {
      this.$root.$data.QualityFilterDate = this.filterDate;
      backendService
        .getDeliveriesWithReportData(new Date(this.filterDate.start), new Date(this.filterDate.end))
        .then(res=> {
          this.$root.$data.statusMessage = 'Leveranser hentet!';
          this.items = JSON.parse(res.request.response).response; 
          this.uniqueDeliveries = DeliveryHelper.getUniqueDeliveries(JSON.parse(res.request.response).response); 
          this.sumRowActive = true
          this.busyState = false;
        })
        .catch(err => {
          console.log(err);
          this.$root.$data.statusMessage = 'Leveranser ikke funnet!';
        });
      }
  }

  filtereDetailsItems(row) {
    var filterTest:  IDelivery[] = [];
    filterTest = this.items.filter(item => item.bilagsnummer === row.item.bilagsnummer);
    return filterTest
  }
 

  hiddenTest() {
    if (this.$route.query.bilagsnummer ) {
      this.$router.replace('/quality')
    }
    if (this.filterDate.end == null) this.filterDate.end = this.today.toISOString()
    this.busyState = true
    this.load()
  }
    
  sumProperty(name: string): number {
    if(this.uniqueDeliveries.length === 0) return 0;
    return this.uniqueDeliveries.map(i => i[name]).reduce((prev, curr) => prev + curr);
  }

  averageProperty(name: string): number {
    if(this.uniqueDeliveries.length === 0) return 0;
    var length = 0  
    this.uniqueDeliveries.forEach((element, index) => {
    if (element[name] != null) {
        length += 1;
      }
    });
    
    return length == 0 ? 0 : this.uniqueDeliveries.map(i => i[name]).reduce((prev, curr) => prev + curr)/length;
  }

  // List must be sorted
  firstDate(): string {
    return moment(this.filterDate.start).format('DD-MM-YYYY')
  }
  // List must be sorted
  lastDate(): string {
    return moment(this.filterDate.end).format('DD-MM-YYYY')
  }

  downloadExcelFile(): void {
    const dateFrom = new Date(this.filterDate.start);
    const dateTo = new Date(this.filterDate.end);
    backendService.getExcelFile(dateFrom, dateTo, "quality");
  }

  fields: BvTableFieldArray = [
    {
      key: 'time',
      label: 'Dato',
      sortable: true,
      formatter: (value, key, item) => {
              return moment(value).format('DD-MM-YYYY');
            }
    },
    {
      key: 'bilagsnummer',
      label: 'Bilagsnummer',
    },
    {
      key: 'vekt',
      label: 'Vekt kg',
    },
    {
      key: 'fuktighet',
      label: 'Fuktighet %',
       formatter: (value, key, item) => { 
        if (item.fuktighet != null) {
          return Number(item.fuktighet).toFixed(2)
        }
        return null  
      }
    },
    {
      key: 'snittBP',
      label: 'BP %',
      formatter: (value, key, item) => { 
        if (item.snittBP != null) {
          return Number(item.snittBP).toFixed(2)
        }
        return null  
      }
    },
    {
      key: 'plast',
      label: 'Plast %',
       formatter: (value, key, item) => { 
        if (item.plast != null) {
          return Number(item.plast).toFixed(2)
        }
        return null  
      }
    },
    {
      key: 'aske',
      label: 'Aske %',
       formatter: (value, key, item) => { 
        if (item.aske != null) {
          return Number(item.aske).toFixed(2)
        }
        return null  
      }
    },
    {
      key: 'lignin',
      label: 'Lignin %',
       formatter: (value, key, item) => { 
        if (item.lignin != null) {
          return Number(item.lignin).toFixed(2)
        }
        return null  
      }
    },
    {
      key: 'snittAP',
      label: 'Annet Papir %',
      formatter: (value, key, item) => { 
        if (item.snittAP != null) {
          return Number(item.snittAP).toFixed(2)
        }
        return null  
      }
    },
    {
      key: 'snittRask',
      label: 'Rask %',
      formatter: (value, key, item) => { 
        if (item.snittRask != null) {
          return Number(item.snittRask).toFixed(2)
        }
        return null  
      }

    },
    {
      key: 'actions',
      label: 'Handlinger',
    }
  ];
     fieldsDetails: BvTableFieldArray = [
    {
      key: 'fuktighet',
      label: 'Fuktighet %',
       formatter: (value, key, item) => { 
        if (item.fuktighet != null) {
          return Number(item.fuktighet).toFixed(2)
        }
        return null  
      }
    },
    {
      key: 'plast',
      label: 'Plast %',
       formatter: (value, key, item) => { 
        if (item.plast != null) {
          return Number(item.plast).toFixed(2)
        }
        return null  
      }
    },
    {
      key: 'aske',
      label: 'Aske %',
       formatter: (value, key, item) => { 
        if (item.aske != null) {
          return Number(item.aske).toFixed(2)
        }
        return null  
      }
    },
    {
      key: 'lignin',
      label: 'Lignin %',
       formatter: (value, key, item) => { 
        if (item.lignin != null) {
          return Number(item.lignin).toFixed(2)
        }
        return null  
      }
    },
  ];
}

